/* hcs-season-band: the band's "Get the alert" link (sections/hcs-season-band.liquid).
   Scrolls to the buy box's back-in-stock form and focuses its email field, as the
   sticky bar's "Notify me" does (sections/sticky-add-to-cart.liquid). Without this
   script the link is a plain #back-in-stock anchor. */
(function () {
  function toAlert(e) {
    var el = document.querySelector('hcs-back-in-stock');
    if (!el || el.hidden) return;
    e.preventDefault();

    /* The form can sit inside a collapsed <details>; open it before scrolling. */
    var node = el.parentElement;
    while (node) {
      if (node.tagName === 'DETAILS' && !node.open) node.open = true;
      node = node.parentElement;
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });

    var input = el.querySelector('.hcs-bis__input');
    if (!input) return;
    /* Focus a beat after the scroll starts: focusing first re-jumps the page. */
    setTimeout(
      function () {
        try {
          input.focus({ preventScroll: true });
        } catch (err) {
          input.focus();
        }
      },
      reduce ? 0 : 320
    );
  }

  document.querySelectorAll('[data-hsb-alert]').forEach(function (link) {
    link.addEventListener('click', toAlert);
  });
})();
